import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Anchor from '../Link/Link';
import Button from '../Button/Button';
import backgroundImage from '../../assets/images/app-min.jpg';
import BackgroundImage from 'gatsby-background-image'

const Card = ({
  titleTag,
  title,
  text,
  url,
  linkText,
  linkLabel,
  linkType,
  url2,
  linkText2,
  linkLabel2,
  linkType2,
  target,
  shadow,
  className,
  image,
  hasFullWidthImage,
  altText,
  type
}) => {
  const Element = titleTag;

  let link = null

  if (!(url ==='#')) {
    link =
      linkType !== 'button' ? (
        <Anchor type="arrow" href={url} target={target} title={linkLabel}>
          {linkText}
        </Anchor>
      ) : (
          <Button
            as="link"
            className={`${type !== 'orange' ? 'primary' : ''} ${url2 ? 'm-full-width' : ''}`}
            target={target}
            href={url}
            title={linkLabel}
          >
            {linkText}
          </Button>
        );
  }

  let link2 = null

  if (!(url2 ==='#')) {
    link2 =
        linkType2 !== 'button' ? (
            <Anchor type="arrow" href={url2} target={target} title={linkLabel2}>
              {linkText2}
            </Anchor>
        ) : (
            <Button
                as="link"
                className={`${type !== 'orange' ? 'primary' : ''}${url2 ? ' m-full-width' : ''}`}
                target={target}
                href={url2}
                title={linkLabel2}
            >
              {linkText2}
            </Button>
        );
  }

  // An alt tag should exist to satisfy WCAG guidelines.
  if (!altText) {
    altText = ""
  }

  let imageElement = <img src={image} alt={altText} />
  let insideTitleWrapper = true

  if (hasFullWidthImage) {
    insideTitleWrapper = false
    imageElement = <BackgroundImage {...image} Tag="div" className="full-width-image"></BackgroundImage>
  }

  return (
    <div className="card-with-image">
      <div className={cn('card large-padding', { shadow }, type, className)}>
        {!insideTitleWrapper && imageElement}
        <div className={`title-wrapper ${titleTag}`}>
          {title && <Element className="title">{title}</Element>}
          {insideTitleWrapper && imageElement}
        </div>
        {text && <p>{text}</p>}
        {url && !(url ==='#') && link}
        {url2 && !(url2 ==='#') && link2}
      </div>
    </div>
  );
};

Card.defaultProps = {
  titleTag: 'h2',
  title: '',
  text: '',
  url: '#',
  linkText: 'Meer informatie',
  url2: '#',
  linkText2: 'Meer informatie',
  target: null,
  image: backgroundImage,
};

Card.propTypes = {
  titleTag: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5']),
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  url: PropTypes.string,
  linkText: PropTypes.string,
  url2: PropTypes.string,
  linkText2: PropTypes.string,
  target: PropTypes.string,
  image: PropTypes.string,
};

export default Card;
